import axios from "axios";
import WriteToLog from "./WriteToLog";   

/**
 * Get prediction data from AAO Model
 * @param {*} patientJSON 
 * @returns 
 */
async function getAAOModelPrediction(patientJSON) {
  let predictionValue = "";
  const ehrconfig = await axios.get('ehrconfig.json');
  let modelPredictionUrl = ehrconfig.data["AAO_MODEL_PREDICTION_URL"];
  //WriteToLog("getAAOModelPrediction: " + JSON.stringify(patientJSON));

  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  };

  try {
      const response = await axios.post(modelPredictionUrl, {"num_risk_factors": 10, "patients": [patientJSON]}, { headers: headers });
      if (response.data !== undefined) {
        WriteToLog("getAAOModelPrediction API response: " + JSON.stringify(response.data));
        if (response.data) {
          predictionValue = response.data;
        }
      }
      return predictionValue;
  } catch (error) {
    WriteToLog("getAAOModelPrediction API service error: " + error.message);
    return null;
  }
}

export default getAAOModelPrediction;
